import { render } from "./DataItem.vue?vue&type=template&id=03ee7174"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"

import "./DataItem.vue?vue&type=style&index=0&id=03ee7174&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__